<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />

            <div class="list-grade">
              <CCol sm="12" class="">
                <CRow class="">
                  <CCard>
                    <CRow class="p-2">
                      <CCol sm="4">Student 1</CCol>
                      <CCol sm="8">
                        :
                        <span class="text-muted">{{
                          request.StudentName1
                        }}</span></CCol
                      >
                      <div style="clear: both"></div>
                      <hr />

                      <CCol sm="4">Parent Student 1</CCol>
                      <CCol sm="8">
                        :
                        <span class="text-muted">{{
                          request.ParentStudent1
                        }}</span></CCol
                      >
                      <div style="clear: both"></div>
                      <hr />

                      <CCol sm="4">Parent Phone Student 1</CCol>
                      <CCol sm="8">
                        :
                        <span class="text-muted">{{
                          request.ParentPhone1
                        }}</span></CCol
                      >
                      <div style="clear: both"></div>
                      <hr />

                      <CCol sm="4">Student 2</CCol>
                      <CCol sm="8">
                        :
                        <span class="text-muted">{{
                          request.StudentName2
                        }}</span></CCol
                      >
                      <div style="clear: both"></div>
                      <hr />

                      <CCol sm="4">Parent Student 2</CCol>
                      <CCol sm="8">
                        :
                        <span class="text-muted">{{
                          request.ParentStudent2
                        }}</span></CCol
                      >
                      <div style="clear: both"></div>
                      <hr />

                      <CCol sm="4">Parent Phone Student 2</CCol>
                      <CCol sm="8">
                        :
                        <span class="text-muted">{{
                          request.ParentPhone2
                        }}</span></CCol
                      >
                      <div style="clear: both"></div>
                      <hr />

                      <CCol sm="4">Teacher</CCol>
                      <CCol sm="8">
                        :
                        <span class="text-muted">{{
                          request.Teacher
                        }}</span></CCol
                      >
                      <div style="clear: both"></div>
                      <hr />
                      <CCol sm="4">Grade</CCol>
                      <CCol sm="8"
                        >:
                        <span class="text-muted">{{
                          request.Grade
                        }}</span></CCol
                      >
                      <div style="clear: both"></div>
                      <hr />

                      <CCol sm="4" lg="4"> <label>Language</label></CCol>
                      <CCol sm="8" lg="8">
                        : <span class="text-muted">{{ request.Language }}</span>
                      </CCol>
                      <div style="clear: both"></div>
                      <hr />

                      <CCol sm="4" lg="4"> <label>Session</label></CCol>
                      <CCol sm="8" lg="8">
                        : <span class="text-muted">{{ request.Session }}</span>
                      </CCol>
                      <div style="clear: both"></div>
                      <hr />
                      <CCol sm="4" lg="4"> <label>Time</label></CCol>
                      <CCol sm="8" lg="8">
                        : <span class="text-muted">{{ request.Time }}</span>
                      </CCol>
                      <div style="clear: both"></div>
                      <hr />
                      <CCol sm="4" lg="4"> <label>Class Duration</label></CCol>
                      <CCol sm="8" lg="8">
                        : <span class="text-muted">{{ request.Duration }}</span>
                      </CCol>
                      <div style="clear: both"></div>
                      <hr />
                      <CCol sm="4" lg="4"> <label>Start Time</label></CCol>
                      <CCol sm="8" lg="8">
                        :
                        <span class="text-muted">
                          {{
                            request.ScheduleDateTime
                              | moment("DD/MM/YYYY hh:mm")
                          }}</span
                        >
                      </CCol>
                    </CRow>
                    <i class="p-2 text-muted"
                      >Note: The starting time is just a preliminary plan that
                      can be adjusted after the tutor talks to both parents</i
                    >
                    <br /><br /><br /><br /><br /><br />
                  </CCard>
                </CRow>
                <div style="clear: both"></div>
                <div class="bottom-center text-center">
                  <div v-if="SuccessButton == true">
                    <CButton
                      style="
                        position: fixed;
                        bottom: 30px;
                        left: 0px;
                        right: 0px;
                        text-align: center;
                        margin: 0 auto;
                        width: 200px;
                      "
                      disabled
                      color="info"
                      class="btn-select-blue mt-5"
                    >
                      Processing
                    </CButton>
                  </div>

                  <div v-if="currentBtn == true">
                    <CButton
                      style="
                        position: fixed;
                        bottom: 30px;
                        left: 0px;
                        right: 0px;
                        text-align: center;
                        margin: 0 auto;
                        width: 200px;
                      "
                      color="info"
                      class="btn-select-green mt-5"
                      @click="DirectGroupOfTwo"
                    >
                      Send Request
                    </CButton>
                  </div>
                </div>
              </CCol>
            </div>
          </div>
        </div>
      </div>
      <MainlayoutBottom></MainlayoutBottom>
    </CContainer>

    <div style="clear: both"></div>
    <div class="header-top">Find Tutor Group Of Two</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div class="header-right">
      <span @click="GoHomePage()"><CIcon name="cil-home" /></span>
      <br />
    </div>
    <div style="clear: both"></div>
  </div>
</template>
  
  <script>
import Vue from "vue";
import _ from "lodash";
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import MainlayoutBottom from "../../containers/TheBottomCustom.vue";

import moment from "moment";
Vue.use(require("vue-moment"));

Vue.use(VuejsDialog);

export default {
  components: {
    MainlayoutBottom,
  },
  data() {
    return {
      user: {},
      request: {},
      //StudentId: this

      languages: [],
      sessions: [],
      times: [],
      dur: [],
      StartTime: "",
      durationID: "",
      currentBtn: true,
      SuccessMessage: false,
      SuccessButton: false,
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
      this.GetRequestWaitingById();
      this.GetLanguages();
      this.GetSession();
      this.GetTimes();
      this.GetDurations();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GoHomePage() {
      this.$router.push("FTClassType");
    },
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetRequestWaitingById();
            this.GetLanguages();
            this.GetSession();
            this.GetTimes();
            this.GetDurations();
          }
        });
    },

    async GetRequestWaitingById() {
      this.$API
        .get(
          this.$GetRequestWaitingById +
            "?requestId=" +
            this.$route.query.requestId +
            "&studentId=" +
            this.$route.query.studentId +
            "&findTutorId=" +
            this.$route.query.FindTutorId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.request = response.data;
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },

    GoToSubject(studentId, gradeId) {
      if (gradeId == 0) {
        this.studentId = studentId;
        this.PopupUpdateGrade = true;
      } else {
        this.$router.push(
          "/FindTutor/FTSubjectGroup?studentId=" +
            studentId +
            "&gradeId=" +
            gradeId
        );
      }
    },

    GoToRegisterStudent() {
      this.$router.push("/RegisterStudent");
    },

    GoBack() {
      this.$router.back();
    },

    GoToSelectStudent(Id) {
      this.$router.push("FTChooseStudent?requestId=" + Id);
    },
    async GetLanguages() {
      return this.$API
        .get(this.$Languages)
        .then(
          function (response) {
            this.languages = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetSession() {
      return this.$API
        .get(this.$Sessions)
        .then(
          function (response) {
            this.sessions = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetTimes() {
      return this.$API
        .get(this.$Times)
        .then(
          function (response) {
            this.times = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetDurations() {
      return this.$API
        .get(this.$Durations)
        .then(
          function (response) {
            this.dur = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    DirectGroupOfTwo() {
      const formData = new FormData();

      formData.append("findTutorID", this.$route.query.FindTutorId);
      formData.append("studentId2", this.$route.query.studentId);
      formData.append("requestWaitingList", this.$route.query.requestId);
      formData.append("StartTime", this.request.ScheduleDateTime);

      return this.$API
        .post(this.$InsertDirectFindTutorGroupingStud2, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (
            response.status == 200 &&
            response.data != null &&
            response.data > 0
          ) {
            this.SuccessButton = true;
            this.currentBtn = false;
          } else {
            this.$dialog.alert("Error.");
            this.errorModal = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$dialog.alert("Error.");
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
  },
};
</script>
  
  <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: 100vh;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}
</style>